import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpSharedVimeoVideoLazy } from '../../../shared/PdpSharedVimeoVideo/PdpSharedVimeoVideoLazy.tsx';

import { type VimeoVideo_videoVimeo$key } from './__generated__/VimeoVideo_videoVimeo.graphql.ts';

const videoVimeoFragment = graphql`
    fragment VimeoVideo_videoVimeo on VideoVimeo {
        vimeoId
    }
`;

export const VimeoVideo: FC<{
    videoVimeo: VimeoVideo_videoVimeo$key;
    heightOffset?: number;
    paused?: boolean;
}> = ({ videoVimeo, heightOffset, paused }) => {
    const videoVimeoData = useFragment(videoVimeoFragment, videoVimeo);

    return (
        <PdpSharedVimeoVideoLazy
            id={videoVimeoData.vimeoId}
            useDefaultControls
            heightOffset={heightOffset}
            paused={paused}
        />
    );
};
